import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '@mui/material';
import FormContext$1 from '../../../cinnamon-core/es/components/forms/FormContext.js';

var _excluded = ["as", "onRemoved"];

/**
 * Button to remove the current Array item.
 */
var ArrayRemover = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayRemover, _React$Component);

  var _super = _createSuper(ArrayRemover);

  function ArrayRemover() {
    var _this;

    _classCallCheck(this, ArrayRemover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      if (_this.context.onRemove) {
        _this.context.onRemove();
      }

      var onRemoved = _this.props.onRemoved;
      if (onRemoved) onRemoved();
    });

    return _this;
  }

  _createClass(ArrayRemover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as;
          _this$props.onRemoved;
          var otherProps = _objectWithoutProperties(_this$props, _excluded);

      var Component = as;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClick
      }), this.props.children);
    }
  }]);

  return ArrayRemover;
}(React.Component);

_defineProperty(ArrayRemover, "defaultProps", {
  as: Button
});

_defineProperty(ArrayRemover, "contextType", FormContext$1);

var ArrayRemover$1 = ArrayRemover;

export { ArrayRemover$1 as default };
